// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pv-2";
export var chatLink = "_pv-0";
export var chatText = "_pv-1";